import { tickerItems } from "./ventureContent";

export const Ticker = () => {
  const track = tickerItems.map((item, i) => {
    const Icon = item.icon;
    return <span className="ticker-item" key={`${item.text}-${i}`}><Icon size={14} strokeWidth={1.75} aria-hidden="true" /><span>{item.text}</span></span>;
  });
  return <section className="ticker" aria-label="ALCRISTAR venture attributes" data-testid="venture-ticker">
    <div className="ticker-track" data-testid="venture-ticker-track">
      <div className="ticker-group">{track}</div>
      <div className="ticker-group" aria-hidden="true">{track}</div>
    </div>
  </section>;
};
